export const uiLabels: { [key: string]: { en: string; de: string } } = {
  number: { en: 'Number', de: 'Nummer' },
  leading: { en: 'Module head', de: 'Leitung' }, // 'Leitung' from TAL, 'Module head' from .po
  ects: { en: 'ECTS', de: 'ECTS' },
  teachingLanguage: { en: 'Teaching language', de: 'Unterrichtssprache' },
  switchToEnglish: { en: 'English Version', de: 'Englische Version' },
  switchToGerman: { en: 'German Version', de: 'Deutsche Version' },
};

// Helper to get a UI label based on currentLang
export const getUiLabel = (key: string, lang: string): string => {
  const entry = uiLabels[key];
  if (!entry) {
    return key
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, (str) => str.toUpperCase()); // Basic prettify
  }
  return lang === 'de' ? entry.de : entry.en; // Default to English
};

export const FIELD_MAP_MAIN: { [key: string]: string } = {
  Bezeichnung: 'BezeichnungD',
  Nummer: 'Nummer',
  LeitungText: 'LeitungText',
  ECTS: 'ECTS',
  Label1: 'LabelD1',
  Memo1: 'MemoD1',
  Label2: 'LabelD2',
  Memo2: 'MemoD2',
  Label3: 'LabelD3',
  Memo3: 'MemoD3',
  Label4: 'LabelD4',
  Memo4: 'MemoD4',
  Label5: 'LabelD5',
  Memo5: 'MemoD5',
  Label6: 'LabelD6',
  Memo6: 'MemoD6',
  Label7: 'LabelD7',
  Memo7: 'MemoD7',
  Label8: 'LabelD8',
  Memo8: 'MemoD8',
  Label9: 'LabelD9',
  Memo9: 'MemoD9',
  Label10: 'LabelD10',
  Memo10: 'MemoD10',
  Label11: 'LabelD11',
  Memo11: 'MemoD11',
  Label12: 'LabelD12',
  Memo12: 'MemoD12',
  Label13: 'LabelD13',
  Memo13: 'MemoD13',
  LabelBemerk: 'LabelDBemerk',
  MemoBemerk: 'MemoDBemerk',
};

export const FIELD_MAP_TRANSLATION: { [key: string]: string } = {
  Bezeichnung: 'BezeichnungE',
  Nummer: 'Nummer',
  LeitungText: 'LeitungText',
  ECTS: 'ECTS',
  Label1: 'LabelE1',
  Memo1: 'MemoE1',
  Label2: 'LabelE2',
  Memo2: 'MemoE2',
  Label3: 'LabelE3',
  Memo3: 'MemoE3',
  Label4: 'LabelE4',
  Memo4: 'MemoE4',
  Label5: 'LabelE5',
  Memo5: 'MemoE5',
  Label6: 'LabelE6',
  Memo6: 'MemoE6',
  Label7: 'LabelE7',
  Memo7: 'MemoE7',
  Label8: 'LabelE8',
  Memo8: 'MemoE8',
  Label9: 'LabelE9',
  Memo9: 'MemoE9',
  Label10: 'LabelE10',
  Memo10: 'MemoE10',
  Label11: 'LabelE11',
  Memo11: 'MemoE11',
  Label12: 'LabelE12',
  Memo12: 'MemoE12',
  Label13: 'LabelE13',
  Memo13: 'MemoE13',
  LabelBemerk: 'LabelEBemerk',
  MemoBemerk: 'MemoEBemerk',
};

// --- Define Prop Types ---
interface ModuleContent {
  '@id': string;
  '@type': string;
  title: string;
  description: string;
  Nummer?: string | null;
  LeitungText?: string | null;
  ECTS?: string | null;
  Unterrichtssprache?: string | null;
  BezeichnungD?: string | null;
  BezeichnungE?: string | null;
  LabelD1?: string | null;
  MemoD1?: string | null;
  LabelD2?: string | null;
  MemoD2?: string | null;
  LabelD3?: string | null;
  MemoD3?: string | null;
  LabelD4?: string | null;
  MemoD4?: string | null;
  LabelD5?: string | null;
  MemoD5?: string | null;
  LabelD6?: string | null;
  MemoD6?: string | null;
  LabelD7?: string | null;
  MemoD7?: string | null;
  LabelD8?: string | null;
  MemoD8?: string | null;
  LabelD9?: string | null;
  MemoD9?: string | null;
  LabelD10?: string | null;
  MemoD10?: string | null;
  LabelD11?: string | null;
  MemoD11?: string | null;
  LabelD12?: string | null;
  MemoD12?: string | null;
  LabelD13?: string | null;
  MemoD13?: string | null;
  LabelDBemerk?: string | null;
  MemoDBemerk?: string | null;
  LabelE1?: string | null;
  MemoE1?: string | null;
  LabelE2?: string | null;
  MemoE2?: string | null;
  LabelE3?: string | null;
  MemoE3?: string | null;
  LabelE4?: string | null;
  MemoE4?: string | null;
  LabelE5?: string | null;
  MemoE5?: string | null;
  LabelE6?: string | null;
  MemoE6?: string | null;
  LabelE7?: string | null;
  MemoE7?: string | null;
  LabelE8?: string | null;
  MemoE8?: string | null;
  LabelE9?: string | null;
  MemoE9?: string | null;
  LabelE10?: string | null;
  MemoE10?: string | null;
  LabelE11?: string | null;
  MemoE11?: string | null;
  LabelE12?: string | null;
  MemoE12?: string | null;
  LabelE13?: string | null;
  MemoE13?: string | null;
  LabelEBemerk?: string | null;
  MemoEBemerk?: string | null;
  // Add LabelE14/MemoE14 if they were in the old template's logic
  LabelE14?: string | null;
  MemoE14?: string | null;
  hauptsprache?: string | null;
  uebersetzung?: string | null;
  [key: string]: any; // Keep for other fields not explicitly listed
}

export interface ModuleViewProps {
  content: ModuleContent;
}
